import { siteInfo, navItems } from '@/mocks/home';

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <span className="text-xl font-heading text-primary-500">{siteInfo.name}</span>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              {siteInfo.slogan}
            </p>
            <p className="mt-2 text-xs text-foreground-500 leading-relaxed">
              韩漫、日漫、国漫热门分类，免费全集下拉式阅读平台。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-3">快速导航</h4>
            <div className="flex flex-col gap-2">
              <a href="#hero" onClick={(e) => { e.preventDefault(); document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">首页</a>
              {navItems.map((item) => (
                <a key={item.href} href={item.href} onClick={(e) => { e.preventDefault(); document.querySelector(item.href)?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">{item.label}</a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-3">热门分类</h4>
            <div className="flex flex-col gap-2">
              <a href="#index" onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">韩漫恋爱</a>
              <a href="#index" onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">国漫玄幻</a>
              <a href="#index" onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">日漫热血</a>
              <a href="#index" onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">悬疑推理</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-3">合作伙伴</h4>
            <p className="text-xs text-foreground-500 leading-relaxed">
              更多合作伙伴即将入驻，敬请期待。
            </p>
          </div>
        </div>

        <div className="mt-8 md:mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有
          </p>
          <p className="text-xs text-foreground-500">
            韩漫日漫国漫热门分类 · 免费全集下拉式阅读
          </p>
        </div>
      </div>
    </footer>
  );
}